// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_intake_draft_status_enum */
var InvIntakeDraftStatusEnum;
(function (InvIntakeDraftStatusEnum) {
    InvIntakeDraftStatusEnum["CAPTURING"] = "CAPTURING";
    InvIntakeDraftStatusEnum["EXTRACTING"] = "EXTRACTING";
    InvIntakeDraftStatusEnum["REVIEW"] = "REVIEW";
    InvIntakeDraftStatusEnum["COMMITTED"] = "COMMITTED";
    InvIntakeDraftStatusEnum["FAILED"] = "FAILED";
    InvIntakeDraftStatusEnum["LABELED"] = "LABELED";
})(InvIntakeDraftStatusEnum || (InvIntakeDraftStatusEnum = {}));
;
export default InvIntakeDraftStatusEnum;
/** Zod schema for inv_intake_draft_status_enum */
export const invIntakeDraftStatusEnum = z.nativeEnum(InvIntakeDraftStatusEnum);
//# sourceMappingURL=InvIntakeDraftStatusEnum.js.map